import { darkColors } from "../../theme/colors";
export var light = {
    handleBackground: "#FAD436"
};
export var dark = {
    handleBackground: darkColors.backgroundAlt
};
